import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const ReviewApi = {
  list: async (args: ParamsProps) => {
    try {
      const config: ReturnType = {
        url: "reviews",
        method: "get",
        params: args?.params,
        authorization: true,
        config: {
          showErr: true,
        },
      };

      if (args.state) {
        config.config.store = {
          key: args?.state,
          action: "set",
        };
      }
      const response = await request(config);
      return response;
    } catch (error: any) {
      throw new Error(error);
    }
  },
  stats: async (args: ParamsProps) => {
    try {
      const config: ReturnType = {
        url: "reviews/stats",
        method: "get",
        params: args?.params,
        authorization: true,
        config: {
          showErr: true,
        },
      };

      if (args.state) {
        config.config.store = {
          key: args?.state,
          action: "set",
        };
      }
      const response = await request(config);
      return response;
    } catch (error: any) {
      throw new Error(error);
    }
  },
};

export default ReviewApi;
